import { FC, useMemo } from "react";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  DATA_E2E_KEY,
  IStyledAttributes,
  NO_VALUE_DISPLAY,
  RideStatusEnum,
} from "@ryde/shared";

import {
  IRideStatusIndicator,
  IRideStatusIndicatorControl,
  RideStatusIndicatorConst,
} from "./ride-status.indicator.models";

export const RideStatusIndicatorStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "status-indicator",
})<IRideStatusIndicatorControl>`
  margin-inline-start: auto;
  color: ${props => props.$leftColor};
  font-size: ${props => props.fontSize || "14px"};
  display: flex;
  align-items: center;
  gap: 4px;
  div {
    background-color: ${props => props.$leftColor};
  }
`;

export const RoundDiv = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "round-div",
})`
  width: 8px;
  height: 8px;
  border-radius: 4px;
`;

export const RideStatusIndicator: FC<IRideStatusIndicator> = ({
  status,
  fontSize,
}) => {
  const info = RideStatusIndicatorConst[status || RideStatusEnum.New];
  const { translateLabel } = useSelectItemsTranslate();
  const statusText = useMemo(() => {
    if (!status || !info?.$translateKey) {
      return NO_VALUE_DISPLAY;
    }

    return translateLabel(info.$translateKey);
  }, [info?.$translateKey, status, translateLabel]);
  return (
    <RideStatusIndicatorStyled
      {...info}
      fontSize={fontSize}
      className="status_indicator"
    >
      <RoundDiv />
      {statusText}
    </RideStatusIndicatorStyled>
  );
};
